import { render, staticRenderFns } from "./ShopBarCodeGoods.vue?vue&type=template&id=eefff476&scoped=true"
import script from "./ShopBarCodeGoods.vue?vue&type=script&lang=ts"
export * from "./ShopBarCodeGoods.vue?vue&type=script&lang=ts"
import style0 from "./ShopBarCodeGoods.vue?vue&type=style&index=0&id=eefff476&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefff476",
  null
  
)

export default component.exports